import React, { Component } from 'react'
import styles from '../../styles/common/responseList.module.css'

export class ResponseListItem extends Component {
    render() {
        const { itemContainer, title } = styles;
        const { response, selectResponse, featureId } = this.props;

        return (
            <div className={itemContainer} onClick={() => selectResponse({featureId ,responseId: response.id})}>
                <span className={title}>{response.title}</span>
            </div>
        )
    }
}

export default ResponseListItem
